import {
  makeLastTwelveMonthsFundMarketNewsList,
  makeFundMarketNewsList
} from '../fundMarketNewsSelectors';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../../../reduxStore/store';
import { INewsItemType } from '../../../types';

const allNewsSelector = createStructuredSelector<
  RootState,
  { fundMarketNewsList: INewsItemType[] }
>({
  fundMarketNewsList: makeFundMarketNewsList()
});

const lastTwelveMonthsNewsSelector = createStructuredSelector<
  RootState,
  { fundMarketNewsList: INewsItemType[] }
>({
  fundMarketNewsList: makeLastTwelveMonthsFundMarketNewsList()
});

// For UI (last 12 months only)
export function useSelectFundMarketNewsList() {
  const { fundMarketNewsList } = useSelector(lastTwelveMonthsNewsSelector);
  return fundMarketNewsList;
}

// For Excel export (all data)
export function useSelectAllFundMarketNewsList() {
  const { fundMarketNewsList } = useSelector(allNewsSelector);
  return fundMarketNewsList;
}
